import { render, staticRenderFns } from "./PicturesForm.vue?vue&type=template&id=97a4e4f6&scoped=true"
import script from "./PicturesForm.vue?vue&type=script&lang=js"
export * from "./PicturesForm.vue?vue&type=script&lang=js"
import style0 from "./PicturesForm.vue?vue&type=style&index=0&id=97a4e4f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a4e4f6",
  null
  
)

export default component.exports